var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../shared/nunjucks.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("C:/Users/alejandro.lorenzo/Desktop/Projects/cloudmine-panel-core/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["templates/browsers-event-types.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"cm-filters-hash\">\r\n    ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "filters");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_1;
if(runtime.isArray(t_3)) {
var t_2 = t_3.length;
for(t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1][0];
frame.set("[object Object]", t_3[t_1][0]);
var t_5 = t_3[t_1][1];
frame.set("[object Object]", t_3[t_1][1]);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "<div class=\"cm-filter\">\r\n\t\t<div class=\"cm-label\">";
output += runtime.suppressValue(t_5, env.opts.autoescape);
output += ":</div>\r\n\t\t<div class=\"cm-values\" data-controller=\"";
output += runtime.suppressValue(t_4, env.opts.autoescape);
output += "\"></div>\r\n\t</div>";
;
}
} else {
t_1 = -1;
var t_2 = runtime.keys(t_3).length;
for(var t_6 in t_3) {
t_1++;
var t_7 = t_3[t_6];
frame.set("field", t_6);
frame.set("title", t_7);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "<div class=\"cm-filter\">\r\n\t\t<div class=\"cm-label\">";
output += runtime.suppressValue(t_7, env.opts.autoescape);
output += ":</div>\r\n\t\t<div class=\"cm-values\" data-controller=\"";
output += runtime.suppressValue(t_6, env.opts.autoescape);
output += "\"></div>\r\n\t</div>";
;
}
}
}
frame = frame.pop();
output += "\r\n\t<div class=\"cm-filter\">\r\n\t\t<div class=\"cm-label\">Event:</div>\r\n\t\t<div class=\"cm-values\" data-controller=\"eventTypes\"></div>\r\n\t</div>\r\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["templates/browsers-event-types.html"] , dependencies)